import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios, { authHeaders } from "../../utils/axios";

export const fetchCompanyDetail = createAsyncThunk(
  "company/fetchCompanyDetail",
  async (id, { rejectWithValue }) => {
    try {
      const res = await Axios.get(
        `${process.env.REACT_APP_BASE_URL}/companies/${id}`,
        authHeaders()
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error.message
      );
    }
  }

);

export const fetchAllCompanies = createAsyncThunk(
  "company/fetchAllCompanies",
  async ({ page, limit, search, status, category_ids, city_ids, verification_status, min_followers, max_followers, min_posts, max_posts, start_date, end_date }, { rejectWithValue }) => {
    console.log("fetchAllCompanies --=-----=-==-===--");
    try {
      let url = `${process.env.REACT_APP_BASE_URL}/companies?page=${page}&limit=${limit}`;
      if (search) url += `&search=${search}`;
      if (status) url += `&status=${status}`;
      if (verification_status) url += `&verification_status=${verification_status}`;
      if (min_followers !== undefined && min_followers !== '') url += `&min_followers=${min_followers}`;
      if (max_followers !== undefined && max_followers !== '') url += `&max_followers=${max_followers}`;
      if (min_posts !== undefined && min_posts !== '') url += `&min_posts=${min_posts}`;
      if (max_posts !== undefined && max_posts !== '') url += `&max_posts=${max_posts}`;
      if (start_date) url += `&start_date=${start_date}`;
      if (end_date) url += `&end_date=${end_date}`;
      
      if (category_ids && category_ids.length > 0) {
        category_ids.forEach(id => {
          url += `&category_ids=${id}`;
        });
      }
      if (city_ids && city_ids.length > 0) {
        city_ids.forEach(id => {
          url += `&city_ids=${id}`;
        });
      }

      const res = await Axios.get(url, authHeaders());

      console.log("res --=-----=-==-===--", res.data);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error.message
      );
    }
  }
);

// Export All Companies to Excel
export const exportAllCompanies = createAsyncThunk(
  "company/exportAllCompanies",
  async ({ search, status, category_ids, city_ids, verification_status, min_followers, max_followers, min_posts, max_posts, start_date, end_date } = {}, { rejectWithValue }) => {
    try {
      let url = `${process.env.REACT_APP_BASE_URL}/companies/export?`;
      const params = new URLSearchParams();

      if (search) params.append("search", search);
      if (status) params.append("status", status);
      if (verification_status) params.append("verification_status", verification_status);
      if (min_followers !== undefined && min_followers !== '') params.append("min_followers", min_followers);
      if (max_followers !== undefined && max_followers !== '') params.append("max_followers", max_followers);
      if (min_posts !== undefined && min_posts !== '') params.append("min_posts", min_posts);
      if (max_posts !== undefined && max_posts !== '') params.append("max_posts", max_posts);
      if (start_date) params.append("start_date", start_date);
      if (end_date) params.append("end_date", end_date);

      if (category_ids && category_ids.length > 0) {
        params.append("category_ids", category_ids.join(","));
      }
      if (city_ids && city_ids.length > 0) {
        params.append("city_ids", city_ids.join(","));
      }

      const res = await Axios.get(`${url}${params.toString()}`, {
        ...authHeaders(),
        responseType: "blob",
      });

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const urlObject = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = urlObject;
      link.download = `companies_export_${Date.now()}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(urlObject);

      return true;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const fetchCompanyPosts = createAsyncThunk(
  "company/fetchCompanyPosts",
  async ({ id, page }, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `${process.env.REACT_APP_BASE_URL}/companies/${id}/posts?page=${page}&limit=10`,
        authHeaders()
      );
      return { data: response.data.data, page };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error.message
      );
    }
  }
);

export const createCompanyPost = createAsyncThunk(
  "company/createCompanyPost",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_BASE_URL}/companies/${id}/posts`,
        data,
        {
          ...authHeaders(),
          headers: {
            ...authHeaders().headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const updateCompanyPost = createAsyncThunk(
  "company/updateCompanyPost",
  async ({ companyId, postId, data }, { rejectWithValue }) => {
    try {
      const response = await Axios.patch(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/posts/${postId}`,
        data,
        {
          ...authHeaders(),
          headers: {
            ...authHeaders().headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const deleteCompanyPost = createAsyncThunk(
  "company/deleteCompanyPost",
  async ({ companyId, postId }, { rejectWithValue }) => {
    try {
      const response = await Axios.delete(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/posts/${postId}`,
        authHeaders()
      );
      return { postId, ...response.data };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const fetchPortfolioDetail = createAsyncThunk(
  "company/fetchPortfolioDetail",
  async ({ companyId, id }, { rejectWithValue }) => {
    try {
      const res = await Axios.get(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/portfolios/${id}`,
        authHeaders()
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error.message
      );
    }
  }
);

export const updatePortfolio = createAsyncThunk(
  "company/updatePortfolio",
  async ({ companyId, id, data }, { rejectWithValue }) => {
    try {
      const res = await Axios.patch(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/portfolios/${id}`,
        data,
        {
          ...authHeaders(),
          headers: {
            ...authHeaders().headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error.message
      );
    }
  }
);

export const deletePortfolio = createAsyncThunk(
  "company/deletePortfolio",
  async ({ companyId, id }, { rejectWithValue }) => {
    try {
      const res = await Axios.delete(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/portfolios/${id}`,
        authHeaders()
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error.message
      );
    }
  }
);

export const fetchCompanyPortfolios = createAsyncThunk(
  "company/fetchCompanyPortfolios",
  async ({ companyId, page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const res = await Axios.get(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/portfolios?page=${page}&limit=${limit}`,
        authHeaders()
      );
      return { data: res.data.data, meta: res.data.meta, page };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const createPortfolio = createAsyncThunk(
  "company/createPortfolio",
  async ({ companyId, data }, { rejectWithValue }) => {
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/portfolios`,
        data,
        {
          ...authHeaders(),
          headers: {
            ...authHeaders().headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const downloadPortfolio = createAsyncThunk(
  "company/downloadPortfolio",
  async ({ companyId, id }, { rejectWithValue }) => {
    try {
      const res = await Axios.get(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/portfolios/${id}/download`,
        authHeaders()
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// Certificates
export const fetchCompanyCertificates = createAsyncThunk(
  "company/fetchCompanyCertificates",
  async ({ companyId, page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const res = await Axios.get(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/certificates?page=${page}&limit=${limit}`,
        authHeaders()
      );
      return { data: res.data.data, meta: res.data.meta, page };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const createCompanyCertificate = createAsyncThunk(
  "company/createCompanyCertificate",
  async ({ companyId, data }, { rejectWithValue }) => {
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/certificates`,
        data,
        {
          ...authHeaders(),
          headers: {
            ...authHeaders().headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const updateCompanyCertificate = createAsyncThunk(
  "company/updateCompanyCertificate",
  async ({ companyId, id, data }, { rejectWithValue }) => {
    try {
      const res = await Axios.patch(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/certificates/${id}`,
        data,
        {
          ...authHeaders(),
          headers: {
            ...authHeaders().headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const deleteCompanyCertificate = createAsyncThunk(
  "company/deleteCompanyCertificate",
  async ({ companyId, id }, { rejectWithValue }) => {
    try {
      const res = await Axios.delete(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/certificates/${id}`,
        authHeaders()
      );
      return { id, ...res.data };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// Products
export const fetchCompanyProducts = createAsyncThunk(
  "company/fetchCompanyProducts",
  async ({ companyId, page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const res = await Axios.get(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/products?page=${page}&limit=${limit}`,
        authHeaders()
      );
      return { data: res.data.data, meta: res.data.meta, page };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const createCompanyProduct = createAsyncThunk(
  "company/createCompanyProduct",
  async ({ companyId, data }, { rejectWithValue }) => {
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/products`,
        data,
        {
          ...authHeaders(),
          headers: {
            ...authHeaders().headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const updateCompanyProduct = createAsyncThunk(
  "company/updateCompanyProduct",
  async ({ companyId, id, data }, { rejectWithValue }) => {
    try {
      const res = await Axios.patch(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/products/${id}`,
        data,
        {
          ...authHeaders(),
          headers: {
            ...authHeaders().headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const deleteCompanyProduct = createAsyncThunk(
  "company/deleteCompanyProduct",
  async ({ companyId, id }, { rejectWithValue }) => {
    try {
      const res = await Axios.delete(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/products/${id}`,
        authHeaders()
      );
      return { id, ...res.data };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// Services
export const fetchCompanyServices = createAsyncThunk(
  "company/fetchCompanyServices",
  async ({ companyId, page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const res = await Axios.get(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/services?page=${page}&limit=${limit}`,
        authHeaders()
      );
      return { data: res.data.data, meta: res.data.meta, page };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const createCompanyService = createAsyncThunk(
  "company/createCompanyService",
  async ({ companyId, data }, { rejectWithValue }) => {
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/services`,
        data,
        {
          ...authHeaders(),
          headers: {
            ...authHeaders().headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const updateCompanyService = createAsyncThunk(
  "company/updateCompanyService",
  async ({ companyId, id, data }, { rejectWithValue }) => {
    try {
      const res = await Axios.patch(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/services/${id}`,
        data,
        {
          ...authHeaders(),
          headers: {
            ...authHeaders().headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const deleteCompanyService = createAsyncThunk(
  "company/deleteCompanyService",
  async ({ companyId, id }, { rejectWithValue }) => {
    try {
      const res = await Axios.delete(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/services/${id}`,
        authHeaders()
      );
      return { id, ...res.data };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// Testimonials
export const fetchCompanyTestimonials = createAsyncThunk(
  "company/fetchCompanyTestimonials",
  async ({ companyId, page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const res = await Axios.get(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/testimonials?page=${page}&limit=${limit}`,
        authHeaders()
      );
      return { data: res.data.data, meta: res.data.meta, page };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const createCompanyTestimonial = createAsyncThunk(
  "company/createCompanyTestimonial",
  async ({ companyId, data }, { rejectWithValue }) => {
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/testimonials`,
        data,
        {
          ...authHeaders(),
          headers: {
            ...authHeaders().headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const updateCompanyTestimonial = createAsyncThunk(
  "company/updateCompanyTestimonial",
  async ({ companyId, id, data }, { rejectWithValue }) => {
    try {
      const res = await Axios.patch(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/testimonials/${id}`,
        data,
        {
          ...authHeaders(),
          headers: {
            ...authHeaders().headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const deleteCompanyTestimonial = createAsyncThunk(
  "company/deleteCompanyTestimonial",
  async ({ companyId, id }, { rejectWithValue }) => {
    try {
      const res = await Axios.delete(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/testimonials/${id}`,
        authHeaders()
      );
      return { id, ...res.data };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const fetchCompanyAwards = createAsyncThunk(
  "company/fetchCompanyAwards",
  async ({ companyId, page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const res = await Axios.get(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/awards?page=${page}&limit=${limit}`,
        authHeaders()
      );
      return { data: res.data.data, meta: res.data.meta, page };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const createCompanyAward = createAsyncThunk(
  "company/createCompanyAward",
  async ({ companyId, data }, { rejectWithValue }) => {
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/awards`,
        data,
        {
          ...authHeaders(),
          headers: {
            ...authHeaders().headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const updateCompanyAward = createAsyncThunk(
  "company/updateCompanyAward",
  async ({ companyId, id, data }, { rejectWithValue }) => {
    try {
      const res = await Axios.patch(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/awards/${id}`,
        data,
        {
          ...authHeaders(),
          headers: {
            ...authHeaders().headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const deleteCompanyAward = createAsyncThunk(
  "company/deleteCompanyAward",
  async ({ companyId, id }, { rejectWithValue }) => {
    try {
      const res = await Axios.delete(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/awards/${id}`,
        authHeaders()
      );
      return { id, ...res.data };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const updateCompanyDetails = createAsyncThunk(
  "company/updateCompanyDetails",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await Axios.patch(
        `${process.env.REACT_APP_BASE_URL}/companies/${id}`,
        data,
        {
          ...authHeaders(),
          headers: {
            ...authHeaders().headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const deleteCompany = createAsyncThunk(
  "company/deleteCompany",
  async (id, { rejectWithValue }) => {
    try {
      const response = await Axios.delete(
        `${process.env.REACT_APP_BASE_URL}/companies/${id}`,
        {
          ...authHeaders(),
        }
      );
      return { id, ...response.data };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const removeCompanyPhoto = createAsyncThunk(
  "company/removeCompanyPhoto",
  async ({ id, type }, { rejectWithValue }) => {
    try {
      const response = await Axios.delete(
        `${process.env.REACT_APP_BASE_URL}/companies/${id}/photo`,
        {
          ...authHeaders(),
          data: { type },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);


export const fetchPendingVerifications = createAsyncThunk(
  "company/fetchPendingVerifications",
  async ({ page = 1, limit = 10, search, status, company_id } = {}, { rejectWithValue }) => {
    try {
      const res = await Axios.get(
        `${process.env.REACT_APP_BASE_URL}/companies/verifications?page=${page}&limit=${limit}${search ? `&search=${search}` : ""}${status ? `&overall_status=${status}` : ""}${company_id ? `&company_id=${company_id}` : ""}`,
        authHeaders()
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error.message
      );
    }
  }
);

// Export Pending Verifications to Excel
export const exportPendingVerifications = createAsyncThunk(
  "company/exportPendingVerifications",
  async ({ search, status } = {}, { rejectWithValue }) => {
    try {
      let url = `${process.env.REACT_APP_BASE_URL}/companies/verifications/export?`;
      const params = new URLSearchParams();

      if (search) params.append("search", search);
      if (status) params.append("overall_status", status);

      const res = await Axios.get(`${url}${params.toString()}`, {
        ...authHeaders(),
        responseType: "blob",
      });

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const urlObject = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = urlObject;
      link.download = `verifications_export_${Date.now()}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(urlObject);

      return true;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const fetchVerificationDetails = createAsyncThunk(
  "company/fetchVerificationDetails",
  async (id, { rejectWithValue }) => {
    try {
      const res = await Axios.get(
        `${process.env.REACT_APP_BASE_URL}/companies/verifications/${id}`,
        authHeaders()
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error.message
      );
    }
  }
);

export const updateVerificationStatus = createAsyncThunk(
  "company/updateVerificationStatus",
  async ({ id, pan_status, business_status, other_documents_status }, { rejectWithValue }) => {
    try {
      const res = await Axios.patch(
        `${process.env.REACT_APP_BASE_URL}/companies/verifications/${id}/status`,
        { pan_status, business_status, other_documents_status },
        authHeaders()
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error.message
      );
    }
  }
);

export const manualVerifyCompany = createAsyncThunk(
  "company/manualVerifyCompany",
  async (companyId, { rejectWithValue }) => {
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_BASE_URL}/companies/verifications/company/${companyId}/verify`,
        {},
        authHeaders()
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error.message
      );
    }
  }
);

export const revokeCompanyVerification = createAsyncThunk(
  "company/revokeCompanyVerification",
  async (companyId, { rejectWithValue }) => {
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_BASE_URL}/companies/verifications/company/${companyId}/revoke`,
        {},
        authHeaders()
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error.message
      );
    }
  }
);

export const changeCompanyStarStatus = createAsyncThunk(
  "company/changeCompanyStarStatus",
  async ({ id, is_star, is_star_company }, { rejectWithValue }) => {
    try {
      const starValue = is_star !== undefined ? is_star : is_star_company;
      const res = await Axios.patch(
        `${process.env.REACT_APP_BASE_URL}/companies/${id}/star-status`,
        { is_star: starValue },
        authHeaders()
      );
      return { id, is_star: starValue, is_star_company: starValue, message: res.data.message };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error.message
      );
    }
  }
);

export const fetchCompanyStats = createAsyncThunk(
  "company/fetchCompanyStats",
  async (_, { rejectWithValue }) => {
    try {
      const res = await Axios.get(
        `${process.env.REACT_APP_BASE_URL}/companies/stats`,
        authHeaders()
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error.message
      );
    }
  }
);

export const fetchCompanyCategories = createAsyncThunk(
  "company/fetchCompanyCategories",
  async ({ page, limit, search } = {}, { rejectWithValue }) => {
    try {
      const res = await Axios.get(
        `/companies/categories?page=${page || 1}&limit=${limit || 1000}&search=${search || ""}`,
        authHeaders()
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

const companySlice = createSlice({
  name: "company",
  initialState: {
    isLoading: false,
    deleteCompanyLoading: false,
    error: null,
    companyDetail: null,
    companyPosts: [],
    postsLoading: false,
    portfolioDetail: null,
    portfolioLoading: false,
    portfolioUpdateLoading: false,
    portfolioDeleteLoading: false,
    allCompanies: [],
    allCompaniesLoading: false,
    allCompaniesMeta: null,
    companyStats: null,
    companyStatsLoading: false,
    pendingVerifications: [],
    pendingVerificationsLoading: false,
    pendingVerificationsMeta: null,
    verificationDetails: null,
    verificationDetailsLoading: false,
    updateVerificationLoading: false,
    createPostLoading: false,
    updatePostLoading: false,
    deletePostLoading: false,
    companyAwards: [],
    companyAwardsMeta: null,
    awardActionLoading: false,
    companyAwardsLoading: false,

    // Portfolios
    companyPortfolios: [],
    companyPortfoliosLoading: false,
    companyPortfoliosMeta: null,
    portfolioActionLoading: false,

    // Certificates
    companyCertificates: [],
    companyCertificatesLoading: false,
    companyCertificatesMeta: null,
    certificateActionLoading: false,

    // Products
    companyProducts: [],
    companyProductsLoading: false,
    companyProductsMeta: null,
    productActionLoading: false,

    // Services
    companyServices: [],
    companyServicesLoading: false,
    companyServicesMeta: null,
    serviceActionLoading: false,
    updateCompanyLoading: false,
    removePhotoLoading: false,


    // Testimonials
    companyTestimonials: [],
    companyTestimonialsLoading: false,
    companyTestimonialsMeta: null,
    testimonialActionLoading: false,

    // Categories
    companyCategories: { data: [] },
    companyCategoriesLoading: false,
    isDetailLoading: false,
    companyListSettings: {
      currentPage: 1,
      limit: { value: 10, label: 10 },
      scrollPosition: 0,
      searchTerm: "",
      cardStatus: "",
      selectedCities: [],
      selectedCategories: [],
      advancedFilters: {},
    },
  },
  reducers: {
    patchCompanyPhoto: (state, action) => {
      const { type, photoData } = action.payload;
      if (state.companyDetail && state.companyDetail.profile) {
        state.companyDetail.profile[type] = photoData;
      }
    },
    setCompanyListSettings: (state, action) => {
      state.companyListSettings = { ...state.companyListSettings, ...action.payload };
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyDetail.pending, (state) => {
        state.isDetailLoading = true;
        state.companyDetail = null;
      })
      .addCase(fetchCompanyDetail.fulfilled, (state, action) => {
        state.isDetailLoading = false;
        state.companyDetail = action.payload.data;
      })
      .addCase(fetchCompanyDetail.rejected, (state, action) => {
        state.isDetailLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchCompanyPosts.pending, (state, action) => {
        state.postsLoading = true;
        if (action.meta.arg.page === 1) {
          state.companyPosts = [];
        }
      })
      .addCase(fetchCompanyPosts.fulfilled, (state, action) => {
        const { data, page } = action.payload;
        state.postsLoading = false;

        if (page === 1) {
          state.companyPosts = data;
        } else {
          state.companyPosts = [...state.companyPosts, ...data];
        }
      })
      .addCase(fetchCompanyPosts.rejected, (state, action) => {
        state.postsLoading = false;
        state.error = action.payload;
      })
      .addCase(createCompanyPost.pending, (state) => {
        state.createPostLoading = true;
      })
      .addCase(createCompanyPost.fulfilled, (state, action) => {
        state.createPostLoading = false;
        if (state.companyDetail) {
          state.companyDetail.total_posts = parseInt(state.companyDetail.total_posts || 0) + 1;
        }
        state.companyPosts = [action.payload.data, ...state.companyPosts];
      })
      .addCase(createCompanyPost.rejected, (state, action) => {
        state.createPostLoading = false;
        state.error = action.payload;
      })
      .addCase(updateCompanyPost.pending, (state) => {
        state.updatePostLoading = true;
      })
      .addCase(updateCompanyPost.fulfilled, (state, action) => {
        state.updatePostLoading = false;
        const index = state.companyPosts.findIndex(
          (post) => post.id === action.payload.data.id
        );
        if (index !== -1) {
          state.companyPosts[index] = action.payload.data;
        }
      })
      .addCase(updateCompanyPost.rejected, (state, action) => {
        state.updatePostLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteCompanyPost.pending, (state) => {
        state.deletePostLoading = true;
      })
      .addCase(deleteCompanyPost.fulfilled, (state, action) => {
        state.deletePostLoading = false;
        if (state.companyDetail && state.companyDetail.total_posts > 0) {
          state.companyDetail.total_posts -= 1;
        }
        state.companyPosts = state.companyPosts.filter(
          (post) => post.id !== action.payload.postId
        );
      })
      .addCase(deleteCompanyPost.rejected, (state, action) => {
        state.deletePostLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchPortfolioDetail.pending, (state) => {
        state.portfolioLoading = true;
        state.portfolioDetail = null;
      })
      .addCase(fetchPortfolioDetail.fulfilled, (state, action) => {
        state.portfolioLoading = false;
        state.portfolioDetail = action.payload.data;
      })
      .addCase(fetchPortfolioDetail.rejected, (state, action) => {
        state.portfolioLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchAllCompanies.pending, (state) => {
        state.allCompaniesLoading = true;
      })
      .addCase(fetchAllCompanies.fulfilled, (state, action) => {
        state.allCompaniesLoading = false;
        state.allCompanies = action.payload?.data?.data || action.payload?.data || [];
        state.allCompaniesMeta = action.payload?.data?.meta || action.payload?.meta || null;
      })
      .addCase(fetchAllCompanies.rejected, (state) => {
        state.allCompaniesLoading = false;
      })
      .addCase(fetchPendingVerifications.pending, (state) => {
        state.pendingVerificationsLoading = true;
      })
      .addCase(fetchPendingVerifications.fulfilled, (state, action) => {
        state.pendingVerificationsLoading = false;
        state.pendingVerifications = action.payload?.data || [];
        state.pendingVerificationsMeta = action.payload?.meta || null;
      })
      .addCase(fetchPendingVerifications.rejected, (state, action) => {
        state.pendingVerificationsLoading = false;
        state.error = action.payload;
      })
      .addCase(updateVerificationStatus.pending, (state) => {
        state.updateVerificationLoading = true;
      })
      .addCase(updateVerificationStatus.fulfilled, (state) => {
        state.updateVerificationLoading = false;
      })
      .addCase(updateVerificationStatus.rejected, (state, action) => {
        state.updateVerificationLoading = false;
        state.error = action.payload;
      })
      .addCase(manualVerifyCompany.pending, (state) => {
        state.updateVerificationLoading = true;
      })
      .addCase(manualVerifyCompany.fulfilled, (state, action) => {
        state.updateVerificationLoading = false;
        if (state.companyDetail) {
          state.companyDetail.is_verified = true;
          if (state.companyDetail.verification) {
            state.companyDetail.verification.overall_status = "approved";
            state.companyDetail.verification.pan_status = "approved";
            state.companyDetail.verification.business_status = "approved";
            state.companyDetail.verification.other_documents_status = "approved";
          } else {
            state.companyDetail.verification = {
              overall_status: "approved",
              pan_status: "approved",
              business_status: "approved",
              other_documents_status: "approved",
            };
          }
        }
      })
      .addCase(manualVerifyCompany.rejected, (state, action) => {
        state.updateVerificationLoading = false;
        state.error = action.payload;
      })
      .addCase(revokeCompanyVerification.pending, (state) => {
        state.updateVerificationLoading = true;
      })
      .addCase(revokeCompanyVerification.fulfilled, (state, action) => {
        state.updateVerificationLoading = false;
        if (state.companyDetail) {
          state.companyDetail.is_verified = false;
          if (state.companyDetail.verification) {
            state.companyDetail.verification.overall_status = "revoked";
          }
        }
      })
      .addCase(revokeCompanyVerification.rejected, (state, action) => {
        state.updateVerificationLoading = false;
        state.error = action.payload;
      })
      .addCase(changeCompanyStarStatus.pending, (state) => {
        state.updateVerificationLoading = true;
      })
      .addCase(changeCompanyStarStatus.fulfilled, (state, action) => {
        state.updateVerificationLoading = false;
        const { is_star } = action.payload;
        if (state.companyDetail) {
          state.companyDetail.is_star = is_star;
          state.companyDetail.is_star_company = is_star;
        }
      })
      .addCase(changeCompanyStarStatus.rejected, (state, action) => {
        state.updateVerificationLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchVerificationDetails.pending, (state) => {
        state.verificationDetailsLoading = true;
        state.verificationDetails = null;
      })
      .addCase(fetchVerificationDetails.fulfilled, (state, action) => {
        state.verificationDetailsLoading = false;
        state.verificationDetails = action.payload.data;
      })
      .addCase(fetchVerificationDetails.rejected, (state, action) => {
        state.verificationDetailsLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchCompanyStats.pending, (state) => {
        state.companyStatsLoading = true;
      })
      .addCase(fetchCompanyStats.fulfilled, (state, action) => {
        state.companyStatsLoading = false;
        state.companyStats = action.payload.data;
      })
      .addCase(fetchCompanyStats.rejected, (state, action) => {
        state.companyStatsLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchCompanyAwards.pending, (state, action) => {
        state.companyAwardsLoading = true;
        if (action.meta.arg.page === 1) state.companyAwards = [];
      })
      .addCase(fetchCompanyAwards.fulfilled, (state, action) => {
        state.companyAwardsLoading = false;
        const { data, meta, page } = action.payload;
        if (page === 1) {
          state.companyAwards = data;
        } else {
          state.companyAwards = [...state.companyAwards, ...data];
        }
        state.companyAwardsMeta = meta;
      })
      .addCase(fetchCompanyAwards.rejected, (state, action) => {
        state.companyAwardsLoading = false;
        state.error = action.payload;
      })
      .addCase(createCompanyAward.pending, (state) => {
        state.awardActionLoading = true;
      })
      .addCase(createCompanyAward.fulfilled, (state, action) => {
        state.awardActionLoading = false;
        state.companyAwards = [action.payload.data, ...(state.companyAwards || [])];
        if (state.companyDetail) {
          state.companyDetail.awards = [action.payload.data, ...(state.companyDetail.awards || [])];
        }
      })
      .addCase(createCompanyAward.rejected, (state, action) => {
        state.awardActionLoading = false;
        state.error = action.payload;
      })
      .addCase(updateCompanyAward.pending, (state) => {
        state.awardActionLoading = true;
      })
      .addCase(updateCompanyAward.fulfilled, (state, action) => {
        state.awardActionLoading = false;
        if (Array.isArray(state.companyAwards)) {
          const index = state.companyAwards.findIndex(a => a.id === action.payload.data.id);
          if (index !== -1) state.companyAwards[index] = action.payload.data;
        }
        if (state.companyDetail && Array.isArray(state.companyDetail.awards)) {
          const index = state.companyDetail.awards.findIndex(a => a.id === action.payload.data.id);
          if (index !== -1) state.companyDetail.awards[index] = action.payload.data;
        }
      })
      .addCase(updateCompanyAward.rejected, (state, action) => {
        state.awardActionLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteCompanyAward.pending, (state) => {
        state.awardActionLoading = true;
      })
      .addCase(deleteCompanyAward.fulfilled, (state, action) => {
        state.awardActionLoading = false;
        if (Array.isArray(state.companyAwards)) {
          state.companyAwards = state.companyAwards.filter(a => a.id !== action.payload.id);
        }
        if (state.companyDetail && Array.isArray(state.companyDetail.awards)) {
          state.companyDetail.awards = state.companyDetail.awards.filter(a => a.id !== action.payload.id);
        }
      })
      .addCase(deleteCompanyAward.rejected, (state, action) => {
        state.awardActionLoading = false;
        state.error = action.payload;
      })

      // Portfolios
      .addCase(fetchCompanyPortfolios.pending, (state, action) => {
        state.companyPortfoliosLoading = true;
        if (action.meta.arg.page === 1) state.companyPortfolios = [];
      })
      .addCase(fetchCompanyPortfolios.fulfilled, (state, action) => {
        state.companyPortfoliosLoading = false;
        const { data, meta, page } = action.payload;
        if (page === 1) {
          state.companyPortfolios = data;
        } else {
          state.companyPortfolios = [...state.companyPortfolios, ...data];
        }
        state.companyPortfoliosMeta = meta;
      })
      .addCase(fetchCompanyPortfolios.rejected, (state, action) => {
        state.companyPortfoliosLoading = false;
        state.error = action.payload;
      })
      .addCase(createPortfolio.pending, (state) => {
        state.portfolioActionLoading = true;
      })
      .addCase(createPortfolio.fulfilled, (state, action) => {
        state.portfolioActionLoading = false;
        state.companyPortfolios = [action.payload.data, ...state.companyPortfolios];
        if (state.companyDetail) {
          state.companyDetail.portfolios = [action.payload.data, ...(state.companyDetail.portfolios || [])];
        }
      })
      .addCase(createPortfolio.rejected, (state, action) => {
        state.portfolioActionLoading = false;
        state.error = action.payload;
      })
      .addCase(updatePortfolio.pending, (state) => {
        state.portfolioUpdateLoading = true;
        state.portfolioActionLoading = true;
      })
      .addCase(updatePortfolio.fulfilled, (state, action) => {
        state.portfolioUpdateLoading = false;
        state.portfolioActionLoading = false;
        state.portfolioDetail = action.payload.data;
        const index = state.companyPortfolios.findIndex(p => p.id === action.payload.data.id);
        if (index !== -1) state.companyPortfolios[index] = action.payload.data;
        if (state.companyDetail && Array.isArray(state.companyDetail.portfolios)) {
          const pIndex = state.companyDetail.portfolios.findIndex(p => p.id === action.payload.id);
          if (pIndex !== -1) state.companyDetail.portfolios[pIndex] = action.payload.data;
        }
      })
      .addCase(updatePortfolio.rejected, (state, action) => {
        state.portfolioUpdateLoading = false;
        state.portfolioActionLoading = false;
        state.error = action.payload;
      })
      .addCase(deletePortfolio.pending, (state) => {
        state.portfolioDeleteLoading = true;
        state.portfolioActionLoading = true;
      })
      .addCase(deletePortfolio.fulfilled, (state, action) => {
        state.portfolioDeleteLoading = false;
        state.portfolioActionLoading = false;
        state.portfolioDetail = null;
        state.companyPortfolios = state.companyPortfolios.filter(p => p.id !== action.meta.arg.id);
        if (state.companyDetail && Array.isArray(state.companyDetail.portfolios)) {
          state.companyDetail.portfolios = state.companyDetail.portfolios.filter(p => p.id !== action.meta.arg.id);
        }
      })
      .addCase(deletePortfolio.rejected, (state, action) => {
        state.portfolioDeleteLoading = false;
        state.portfolioActionLoading = false;
        state.error = action.payload;
      })

      // Certificates
      .addCase(fetchCompanyCertificates.pending, (state, action) => {
        state.companyCertificatesLoading = true;
        if (action.meta.arg.page === 1) state.companyCertificates = [];
      })
      .addCase(fetchCompanyCertificates.fulfilled, (state, action) => {
        state.companyCertificatesLoading = false;
        const { data, meta, page } = action.payload;
        if (page === 1) {
          state.companyCertificates = data;
        } else {
          state.companyCertificates = [...state.companyCertificates, ...data];
        }
        state.companyCertificatesMeta = meta;
      })
      .addCase(fetchCompanyCertificates.rejected, (state, action) => {
        state.companyCertificatesLoading = false;
        state.error = action.payload;
      })
      .addCase(createCompanyCertificate.pending, (state) => {
        state.certificateActionLoading = true;
      })
      .addCase(createCompanyCertificate.fulfilled, (state, action) => {
        state.certificateActionLoading = false;
        state.companyCertificates = [action.payload.data, ...state.companyCertificates];
        if (state.companyDetail) {
          state.companyDetail.certificates = [action.payload.data, ...(state.companyDetail.certificates || [])];
        }
      })
      .addCase(createCompanyCertificate.rejected, (state, action) => {
        state.certificateActionLoading = false;
        state.error = action.payload;
      })
      .addCase(updateCompanyCertificate.pending, (state) => {
        state.certificateActionLoading = true;
      })
      .addCase(updateCompanyCertificate.fulfilled, (state, action) => {
        state.certificateActionLoading = false;
        const index = state.companyCertificates.findIndex(c => c.id === action.payload.data.id);
        if (index !== -1) state.companyCertificates[index] = action.payload.data;
        if (state.companyDetail && Array.isArray(state.companyDetail.certificates)) {
          const cIndex = state.companyDetail.certificates.findIndex(c => c.id === action.payload.data.id);
          if (cIndex !== -1) state.companyDetail.certificates[cIndex] = action.payload.data;
        }
      })
      .addCase(updateCompanyCertificate.rejected, (state, action) => {
        state.certificateActionLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteCompanyCertificate.pending, (state) => {
        state.certificateActionLoading = true;
      })
      .addCase(deleteCompanyCertificate.fulfilled, (state, action) => {
        state.certificateActionLoading = false;
        state.companyCertificates = state.companyCertificates.filter(c => c.id !== action.payload.id);
        if (state.companyDetail && Array.isArray(state.companyDetail.certificates)) {
          state.companyDetail.certificates = state.companyDetail.certificates.filter(c => c.id !== action.payload.id);
        }
      })
      .addCase(deleteCompanyCertificate.rejected, (state, action) => {
        state.certificateActionLoading = false;
        state.error = action.payload;
      })

      // Products
      .addCase(fetchCompanyProducts.pending, (state, action) => {
        state.companyProductsLoading = true;
        if (action.meta.arg.page === 1) state.companyProducts = [];
      })
      .addCase(fetchCompanyProducts.fulfilled, (state, action) => {
        state.companyProductsLoading = false;
        const { data, meta, page } = action.payload;
        if (page === 1) {
          state.companyProducts = data;
        } else {
          state.companyProducts = [...state.companyProducts, ...data];
        }
        state.companyProductsMeta = meta;
      })
      .addCase(fetchCompanyProducts.rejected, (state, action) => {
        state.companyProductsLoading = false;
        state.error = action.payload;
      })
      .addCase(createCompanyProduct.pending, (state) => {
        state.productActionLoading = true;
      })
      .addCase(createCompanyProduct.fulfilled, (state, action) => {
        state.productActionLoading = false;
        state.companyProducts = [action.payload.data, ...state.companyProducts];
        if (state.companyDetail) {
          state.companyDetail.products = [action.payload.data, ...(state.companyDetail.products || [])];
        }
      })
      .addCase(createCompanyProduct.rejected, (state, action) => {
        state.productActionLoading = false;
        state.error = action.payload;
      })
      .addCase(updateCompanyProduct.pending, (state) => {
        state.productActionLoading = true;
      })
      .addCase(updateCompanyProduct.fulfilled, (state, action) => {
        state.productActionLoading = false;
        const index = state.companyProducts.findIndex(p => p.id === action.payload.data.id);
        if (index !== -1) state.companyProducts[index] = action.payload.data;
        if (state.companyDetail && Array.isArray(state.companyDetail.products)) {
          const pIndex = state.companyDetail.products.findIndex(p => p.id === action.payload.data.id);
          if (pIndex !== -1) state.companyDetail.products[pIndex] = action.payload.data;
        }
      })
      .addCase(updateCompanyProduct.rejected, (state, action) => {
        state.productActionLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteCompanyProduct.pending, (state) => {
        state.productActionLoading = true;
      })
      .addCase(deleteCompanyProduct.fulfilled, (state, action) => {
        state.productActionLoading = false;
        state.companyProducts = state.companyProducts.filter(p => p.id !== action.payload.id);
        if (state.companyDetail && Array.isArray(state.companyDetail.products)) {
          state.companyDetail.products = state.companyDetail.products.filter(p => p.id !== action.payload.id);
        }
      })
      .addCase(deleteCompanyProduct.rejected, (state, action) => {
        state.productActionLoading = false;
        state.error = action.payload;
      })

      // Services
      .addCase(fetchCompanyServices.pending, (state, action) => {
        state.companyServicesLoading = true;
        if (action.meta.arg.page === 1) state.companyServices = [];
      })
      .addCase(fetchCompanyServices.fulfilled, (state, action) => {
        state.companyServicesLoading = false;
        const { data, meta, page } = action.payload;
        if (page === 1) {
          state.companyServices = data;
        } else {
          state.companyServices = [...state.companyServices, ...data];
        }
        state.companyServicesMeta = meta;
      })
      .addCase(fetchCompanyServices.rejected, (state, action) => {
        state.companyServicesLoading = false;
        state.error = action.payload;
      })
      .addCase(createCompanyService.pending, (state) => {
        state.serviceActionLoading = true;
      })
      .addCase(createCompanyService.fulfilled, (state, action) => {
        state.serviceActionLoading = false;
        state.companyServices = [action.payload.data, ...state.companyServices];
        if (state.companyDetail) {
          state.companyDetail.services = [action.payload.data, ...(state.companyDetail.services || [])];
        }
      })
      .addCase(createCompanyService.rejected, (state, action) => {
        state.serviceActionLoading = false;
        state.error = action.payload;
      })
      .addCase(updateCompanyService.pending, (state) => {
        state.serviceActionLoading = true;
      })
      .addCase(updateCompanyService.fulfilled, (state, action) => {
        state.serviceActionLoading = false;
        const index = state.companyServices.findIndex(s => s.id === action.payload.data.id);
        if (index !== -1) state.companyServices[index] = action.payload.data;
        if (state.companyDetail && Array.isArray(state.companyDetail.services)) {
          const sIndex = state.companyDetail.services.findIndex(s => s.id === action.payload.data.id);
          if (sIndex !== -1) state.companyDetail.services[sIndex] = action.payload.data;
        }
      })
      .addCase(updateCompanyService.rejected, (state, action) => {
        state.serviceActionLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteCompanyService.pending, (state) => {
        state.serviceActionLoading = true;
      })
      .addCase(deleteCompanyService.fulfilled, (state, action) => {
        state.serviceActionLoading = false;
        state.companyServices = state.companyServices.filter(s => s.id !== action.payload.id);
        if (state.companyDetail && Array.isArray(state.companyDetail.services)) {
          state.companyDetail.services = state.companyDetail.services.filter(s => s.id !== action.payload.id);
        }
      })
      .addCase(deleteCompanyService.rejected, (state, action) => {
        state.serviceActionLoading = false;
        state.error = action.payload;
      })

      // Testimonials
      .addCase(fetchCompanyTestimonials.pending, (state, action) => {
        state.companyTestimonialsLoading = true;
        if (action.meta.arg.page === 1) state.companyTestimonials = [];
      })
      .addCase(fetchCompanyTestimonials.fulfilled, (state, action) => {
        state.companyTestimonialsLoading = false;
        const { data, meta, page } = action.payload;
        if (page === 1) {
          state.companyTestimonials = data;
        } else {
          state.companyTestimonials = [...state.companyTestimonials, ...data];
        }
        state.companyTestimonialsMeta = meta;
      })
      .addCase(fetchCompanyTestimonials.rejected, (state, action) => {
        state.companyTestimonialsLoading = false;
        state.error = action.payload;
      })
      .addCase(createCompanyTestimonial.pending, (state) => {
        state.testimonialActionLoading = true;
      })
      .addCase(createCompanyTestimonial.fulfilled, (state, action) => {
        state.testimonialActionLoading = false;
        state.companyTestimonials = [action.payload.data, ...state.companyTestimonials];
        if (state.companyDetail) {
          state.companyDetail.testimonials = [action.payload.data, ...(state.companyDetail.testimonials || [])];
        }
      })
      .addCase(createCompanyTestimonial.rejected, (state, action) => {
        state.testimonialActionLoading = false;
        state.error = action.payload;
      })
      .addCase(updateCompanyTestimonial.pending, (state) => {
        state.testimonialActionLoading = true;
      })
      .addCase(updateCompanyTestimonial.fulfilled, (state, action) => {
        state.testimonialActionLoading = false;
        const index = state.companyTestimonials.findIndex(t => t.id === action.payload.data.id);
        if (index !== -1) state.companyTestimonials[index] = action.payload.data;
        if (state.companyDetail && Array.isArray(state.companyDetail.testimonials)) {
          const tIndex = state.companyDetail.testimonials.findIndex(t => t.id === action.payload.data.id);
          if (tIndex !== -1) state.companyDetail.testimonials[tIndex] = action.payload.data;
        }
      })
      .addCase(updateCompanyTestimonial.rejected, (state, action) => {
        state.testimonialActionLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteCompanyTestimonial.pending, (state) => {
        state.testimonialActionLoading = true;
      })
      .addCase(deleteCompanyTestimonial.fulfilled, (state, action) => {
        state.testimonialActionLoading = false;
        state.companyTestimonials = state.companyTestimonials.filter(t => t.id !== action.payload.id);
        if (state.companyDetail && Array.isArray(state.companyDetail.testimonials)) {
          state.companyDetail.testimonials = state.companyDetail.testimonials.filter(t => t.id !== action.payload.id);
        }
      })
      .addCase(deleteCompanyTestimonial.rejected, (state, action) => {
        state.testimonialActionLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteCompany.pending, (state) => {
        state.deleteCompanyLoading = true;
      })
      .addCase(deleteCompany.fulfilled, (state, action) => {
        state.deleteCompanyLoading = false;
        state.allCompanies = state.allCompanies.filter(c => c.id !== action.payload.id);
        if (state.companyDetail && state.companyDetail.id === action.payload.id) {
          state.companyDetail = null;
        }
      })
      .addCase(deleteCompany.rejected, (state, action) => {
        state.deleteCompanyLoading = false;
        state.error = action.payload;
      })
      .addCase(updateCompanyDetails.pending, (state) => {
        state.updateCompanyLoading = true;
      })
      .addCase(updateCompanyDetails.fulfilled, (state, action) => {
        state.updateCompanyLoading = false;
        const updatedCompany = action.payload.data;
        
        if (updatedCompany) {
          // 1. Update Detail State
          if (state.companyDetail) {
            state.companyDetail = {
              ...state.companyDetail,
              ...updatedCompany,
              profile: {
                ...state.companyDetail.profile,
                ...(updatedCompany.profile || {})
              }
            };
          }

          // 2. Update List State
          if (Array.isArray(state.allCompanies)) {
            const companyIndex = state.allCompanies.findIndex(c => c.id === updatedCompany.id);
            if (companyIndex !== -1) {
              state.allCompanies[companyIndex] = {
                ...state.allCompanies[companyIndex],
                ...updatedCompany,
                profile: {
                  ...state.allCompanies[companyIndex].profile,
                  ...(updatedCompany.profile || {})
                }
              };
            }
          }
        }
      })
      .addCase(updateCompanyDetails.rejected, (state, action) => {
        state.updateCompanyLoading = false;
        state.error = action.payload;
      })
      .addCase(removeCompanyPhoto.pending, (state) => {
        state.removePhotoLoading = true;
      })
      .addCase(removeCompanyPhoto.fulfilled, (state) => {
        state.removePhotoLoading = false;
      })
      .addCase(removeCompanyPhoto.rejected, (state, action) => {
        state.removePhotoLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchCompanyCategories.pending, (state) => {
        state.companyCategoriesLoading = true;
      })
      .addCase(fetchCompanyCategories.fulfilled, (state, action) => {
        state.companyCategoriesLoading = false;
        state.companyCategories = action.payload || { data: [] };
      })
      .addCase(fetchCompanyCategories.rejected, (state, action) => {
        state.companyCategoriesLoading = false;
        state.error = action.payload;
      });

  },
});

export const { patchCompanyPhoto, setCompanyListSettings } = companySlice.actions;

export default companySlice.reducer;
